var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLucentLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 44 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M43.326 20.45s-5.042.59-10.374-8.3c0 0-5.042-9.778-16.893-12.15 0 0 8.592 2.961 8.592 12.746 0 0-.298 10.672 7.115 12.149 0 0 6.518.888 11.56-4.445Z",
  fill: "#98D9E9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.325 20.372S24.95 24.817 15.47 4.07c0 0 3.26 16.893 15.41 18.675 0 0 9.926 1.775 12.446-2.372Z",
  fill: "#00547E",
  opacity: 0.7
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.736 13.264S29.7 32.975 2.724 21.338c0 0 13.335 10.303 26.677 6.447 0 0 9.778-3.26 13.335-14.52Z",
  fill: "#00547E"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M42.736 12.966s-.888 5.333-18.078 1.186c0 0-11.56-3.855-24.306 2.961 0 0 12.15-3.855 18.966 5.631 0 0 8.89 9.778 18.079 3.558 0 0 5.333-4.148 5.333-13.336",
  fill: "#35B0C8",
  opacity: 0.6
})));
export default SvgLucentLogo;